export const assetUrlToCDNUrl = (assetUrl?: string) => {
  if (!assetUrl) {
    return assetUrl;
  }

  if (
    assetUrl.startsWith(
      'https://firebasestorage.googleapis.com/v0/b/cyder-ai.appspot.com/o/',
    )
  ) {
    const url = new URL(
      assetUrl.replace(
        'https://firebasestorage.googleapis.com/v0/b/cyder-ai.appspot.com/o/',
        'https://cdn.betterfunnel.ai/',
      ),
    );
    const path = decodeURIComponent(url.pathname);
    return `https://cdn.betterfunnel.ai${path}`;
  }

  return assetUrl;
};
